// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2qmSX","resendInfoText":"OnGoingPaymentBox_resendInfoText__uG2uh"};